module.exports = __webpack_public_path__ + "media/tile-1-image.ebbcbf9c.jpg";